module.exports = __webpack_public_path__ + "img/metodologia.6a383385.webp";